import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {
	outer: {
		width: '100%',
		marginTop: '1em',
	},

	center: {
		width: '50%',
		margin: '0 auto',
	},
};

// Horizontally centered indeterminate progress circle
const IndeterminateCircularProgress = props => {
	const { classes, isVisible, size, thickness } = props;
	return !isVisible ? null : (
		<div className={classes.outer}>
			<CircularProgress
				color="secondary"
				className={classes.center}
				size={size}
				thickness={thickness}
				// Must be overridden to center the progress circle
				style={{ display: 'block' }}
			/>
		</div>
	);
};

IndeterminateCircularProgress.propTypes = {
	size: PropTypes.number,
	thickness: PropTypes.number,
	isVisible: PropTypes.bool,
	classes: PropTypes.shape({
		outer: PropTypes.string,
		inner: PropTypes.string,
	}).isRequired,
};

// Default values found in CircularProgress
IndeterminateCircularProgress.defaultProps = {
	isVisible: true,
	size: 40,
	thickness: 3,
};

// Testing
export { IndeterminateCircularProgress as CircularProgressClass };

export default withStyles(styles, { name: 'IndeterminateCircularProgress' })(
	IndeterminateCircularProgress,
);
